export const NoSuccessErrorHandler = {
    onSuccess: () => {},
    onError: () => {}
};

export enum API_REQUEST_TYPE {
    DATABASE,
    ELASTIC_SEARCH
}
export enum ApiKeyFilter {
    ALL = 0,
    TRUE = 1,
    FALSE = 2
}

export const ApiKeyFilterToBooleanMap = {
    [ApiKeyFilter.ALL]: undefined,
    [ApiKeyFilter.TRUE]: true,
    [ApiKeyFilter.FALSE]: false
};
